import { render, staticRenderFns } from "./StatisticDefaultLayout.vue?vue&type=template&id=7827a617&scoped=true&"
import script from "./StatisticDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./StatisticDefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./StatisticDefaultLayout.vue?vue&type=style&index=0&id=7827a617&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827a617",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
